import { useEffect, useState } from 'react';

import { Badge, Button, TextField } from '@mui/material';

import PropTypes from 'prop-types';

import _ from 'lodash';

import { useRouter } from 'next/router';

import { PriceRangeSlider } from '../shared';

const PriceRangeFilterButton = (props) => {

    let data = Object.values(props.roomTypes);

    const minValue = Math.min(...data.map((item) => item.startingPrice));

    const maxValue = Math.max(...data.map((item) => item.startingPrice));

    const defaultSelectedMin = minValue;

    const defaultSelectedMax = maxValue;

    const { children, onChange } = props;

    const [openModal, setOpenModel] = useState(false);

    const [badgeCount, setBadgeCount] = useState(0);

    const [selectedPriceRange, setSelectedPriceRange] = useState([
        defaultSelectedMin,
        defaultSelectedMax,
    ]);

    const router = useRouter();
    
    const { query } = router;

    useEffect(() => {
        getPriceRangeFromQuery();
        checkBadgeCount();
    }, [query]);

    const onFilterClick = () => {
        setOpenModel(true);
    };

    const onModalClose = () => {
        setOpenModel(false);
    };

    const checkBadgeCount = () => {
        let count = 0;
        const priceMinParam = _.get(query, 'priceMin');
        const priceMaxParam = _.get(query, 'priceMax');
        if (
            (priceMinParam && priceMinParam !== defaultSelectedMin.toString()) ||
            (priceMaxParam && priceMaxParam !== defaultSelectedMax.toString())
        ) {
            count += 1;
        }
        setBadgeCount(count);
    };

    const onPriceRangeChange = (values) => {
        setSelectedPriceRange(values);
        if (values[0] >= minValue && values[1] <= maxValue) {
            if (onChange) {
                onChange(values);
            }
        }
    };

    const getPriceRangeFromQuery = () => {
        const priceMin = parseInt(_.get(query, 'priceMin'), 10);
        const priceMax = parseInt(_.get(query, 'priceMax'), 10);
        if (priceMin && priceMax) {
            setSelectedPriceRange([priceMin, priceMax]);
        } else if (priceMin && !priceMax) {
            setSelectedPriceRange([priceMin, selectedPriceRange[1]]);
        } else if (priceMax && !priceMin) {
            setSelectedPriceRange([selectedPriceRange[0], priceMax]);
        } else {
            setSelectedPriceRange([defaultSelectedMin, defaultSelectedMax]);
        }
    };

    const onBlurMin = (e) => {
        if (e.target.value < minValue) {
            setSelectedPriceRange([minValue, selectedPriceRange[1]]);
            if (onChange) {
                onChange([minValue, selectedPriceRange[1]]);
            }
        }
    };

    const onBlurMax = (e) => {
        if (e.target.value > maxValue) {
            setSelectedPriceRange([selectedPriceRange[0], maxValue]);
            if (onChange) {
                onChange([selectedPriceRange[0], maxValue]);
            }
        }
    };

    const renderPriceRangeSlider = () => {
        return (
            <div id="price-range-filter-button-container" className='price-range-filter-button-container'>
                <PriceRangeSlider
                    min={minValue}
                    max={maxValue}
                    defaultValues={selectedPriceRange}
                    onChange={(values) => onPriceRangeChange(values)}
                />
                <div id="price-range-filter-price-container" className='price-range-filter-price-container'>
                    <div>
                        <h6 style={{ color: '#D2D3D4' }}>Min Price</h6>

                        <TextField
                            color="secondary"
                            id="min-input"
                            label=""
                            variant="outlined"
                            type="number"
                            slotProps={{
                                inputProps: {
                                    min: minValue,
                                    max: maxValue,
                                },
                            }}
                            onBlur={onBlurMin}
                            value={[selectedPriceRange[0]]}
                            onChange={(e) =>
                                onPriceRangeChange([e.target.value, selectedPriceRange[1]])
                            }
                            className='price-range-filter-text-field'
                        />
                    </div>
                    <hr className='price-range-filter-divider' />
                    <div>
                        <h6 style={{ color: '#D2D3D4' }}>Max Price</h6>

                        <TextField
                            color="secondary"
                            id="max-input"
                            label=""
                            type="number"
                            variant="outlined"
                            slotProps={{
                                inputProps: {
                                    min: minValue,
                                    max: maxValue,
                                },
                            }}
                            onBlur={onBlurMax}
                            value={[selectedPriceRange[1]]}
                            onChange={(e) =>
                                onPriceRangeChange([selectedPriceRange[0], e.target.value])
                            }
                            className='price-range-filter-text-field'
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='price-range-filter-container'>
            <Button
                id="price-filter-button"
                badge={badgeCount > 0 ? badgeCount : 0}
                className={badgeCount > 0 ? 'price-filter-badge' : 'price-filter-no-badge'}
                onClick={onFilterClick}
            >
                <Badge badgeContent={badgeCount}>
                    {children}
                </Badge>
            </Button>
            {openModal && (
                <div>
                    <div className='price-range-filter-modal-overlay' onClick={onModalClose} />
                    <div className='price-range-filter-modal-container'>{renderPriceRangeSlider()}</div>
                </div>
            )}
        </div>
    );
};

PriceRangeFilterButton.propTypes = {
    children: PropTypes.string,
    roomTypes: PropTypes.array,

    onChange: PropTypes.func,
};

export default PriceRangeFilterButton;


